



































































import Breadcrumb from '@/components/Breadcrumb.vue';
import Table from '@/components/Table/Index.vue';
import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import GeneralModule from '@/store/modules/General';
import MarketingReportModule from '@/store/modules/MarketingReport';
import MarketingReportData from '@/data/MarketingReportData';
import MarketingReportBody from '@/components/Table/MarketingReportBody.vue';
import ManageMixin from '@/mixins/Manage.vue';

@Component({
  components: {
    Table,
    MarketingReportBody,
    Breadcrumb,
  },
})
export default class MarketingReport extends Mixins(
  ToolMixin, ErrorHandleMixin, ManageMixin,
) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  TableHead = [...MarketingReportData.TableHeadMarketingReport];

  MarketingReportInstance = getModule(MarketingReportModule, this.$store);

  reportList: any = [];

  reportData: any = [];

  footerData: any = []

  endDate = '';

  startDate = '';

  componentKey = 0;

  stage = '';

  idx = 0;

  Criteria = {
    ...this.Period,
  };

  breadcrumb: any = [];

  BreadcrumbList: any = [];

  BreadcrumbDefualt: any = [
    {
      username: 'Main',
      value: '',
    },
  ];

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchperiod() {
    const datestart = this.$moment(this.Period.start.date).format('L');
    this.startDate = this.$moment(datestart).format('DD-MM-YYYY');
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchperiod2() {
    const dateend = this.$moment(this.Period.end.date).format('L');
    this.endDate = this.$moment(dateend).format('DD-MM-YYYY');
  }

  created() {
    this.fetchMarketingReport();
  }

  initial() {
    this.currentTool = 'Today';
    this.Period = {
      start: {
        date: this.$moment().startOf('day').toDate(),
      },
      end: {
        date: this.$moment().endOf('day').toDate(),
      },
    };
  }

  async fetchMarketingReport() {
    this.GeneralInstance.toggleLoading(true);
    const criteria = { ...this.Period };
    const data = await this.MarketingReportInstance.FetchMarteingReport(criteria);
    this.stage = 'Main';
    this.reportList = data;
    this.stageData();
    this.GeneralInstance.toggleLoading(false);
  }

  onSubmit() {
    this.fetchMarketingReport();
  }

  handleBreadcrumb() {
    this.fetchMarketingReport();
  }

  stageData() {
    if (this.stage === 'Main') {
      this.reportData = this.reportList.ancestor;
      this.footerData = this.reportList.footer;
      this.BreadcrumbList = [];
    } else {
      this.reportData = this.reportList.ancestor[this.idx].detail;
      this.footerData = this.reportList.ancestor[this.idx];
    }
    this.breadcrumb = [...this.BreadcrumbDefualt, ...this.BreadcrumbList];
    this.componentKey += 1;
  }

  handleFetchReportProvider(name) {
    if (name === 'Game Market') this.idx = 0;
    if (name === 'Legend Of Dolly') this.idx = 1;
    this.stage = 'Detail';
    this.BreadcrumbList.push({
      username: name,
      value: '',
    });
    this.stageData();
  }
}
